import React from 'react'
import { FaEdit } from 'react-icons/fa'
import { getMediaUrl, isVideo, formatFileSize } from '../../utils/mediaUtils'

const MediaViewer = ({ selectedMedia, onEditPhoto }) => {
  const isImage = selectedMedia.mimetype && selectedMedia.mimetype.startsWith('image/')

  return (
    <div className="space-y-4">
      {isVideo(selectedMedia.mimetype) ? (
        <video
          src={getMediaUrl(selectedMedia)}
          controls
          className="w-full rounded-xl"
          preload="metadata"
        />
      ) : (
        <div className="relative">
          <img
            src={getMediaUrl(selectedMedia)}
            alt={selectedMedia.customName || selectedMedia.originalName}
            className="w-full rounded-xl"
            loading="eager"
            decoding="async"
          />
          {isImage && onEditPhoto && (
            <button
              onClick={() => onEditPhoto(selectedMedia)}
              className="absolute top-4 right-4 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-lg shadow-lg transition-all flex items-center gap-2"
            >
              <FaEdit />
              <span className="font-medium">Edit Photo</span>
            </button>
          )}
        </div>
      )}

      <MediaInfo
        selectedMedia={selectedMedia}
        formatFileSize={formatFileSize}
      />
    </div>
  )
}

const MediaInfo = ({ selectedMedia, formatFileSize }) => (
  <div className="space-y-2">
    <div className="flex justify-between text-sm">
      <span className="text-gray-400">Size:</span>
      <span className="text-white">{formatFileSize(selectedMedia.size)}</span>
    </div>
    <div className="flex justify-between text-sm">
      <span className="text-gray-400">Type:</span>
      <span className="text-white">{selectedMedia.mimetype}</span>
    </div>
    <div className="flex justify-between text-sm">
      <span className="text-gray-400">Uploaded:</span>
      <span className="text-white">
        {new Date(selectedMedia.uploadedAt).toLocaleDateString()}
      </span>
    </div>
  </div>
)

export default MediaViewer